import client from '@/api/client'

export async function getLaunchPadWidgetData() {
    try {
        return await client.get(`/company/launch-pad`)
    } catch (e) {
        return {
            data: {
                success: false,
                msg: 'Something went wrong. Please get in touch with our onboarding team.',
            },
        }
    }
}

export async function setLaunchPadWidgetLive() {
    try {
        return await client.get(`/company/launch-pad?launchPadLive=1`)
    } catch (e) {
        return {
            data: {
                success: false,
                msg: 'Something went wrong. Please get in touch with our onboarding team.',
            },
        }
    }
}

export async function setOnboardingToLive() {
    try {
        return await client.post(
            `/ajax/company/test-mode-live`,
            {},
            { baseURL: '/' }
        )
    } catch (e) {
        return {
            data: {
                success: false,
                msg: 'Something went wrong. Please get in touch with our onboarding team.',
            },
        }
    }
}

export async function getRecommendedNextSteps() {
    try {
        return await client.get(`/company/recommended-next-steps`)
    } catch (e) {
        return {
            data: {
                success: false,
                msg: 'Something went wrong. Please get in touch with our onboarding team.',
            },
        }
    }
}
